module.exports = __webpack_public_path__ + "img/1-4.f4fe5e5a.svg";